import styled from 'styled-components';

export const CheckoutCardWrapper = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 380px;
`;

export const CheckoutCardDesktopWrapper = styled.div`
  align-self: stretch;
  min-width: 395px;
`;

export const Card = styled.div<{ dataCy?: string }>`
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
  background-color: ${({ theme }) => theme.color.grey100};
`;

export const Divider = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
